var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alarmData"},[_c('searchs',{attrs:{"initPomer":_vm.initPome},on:{"Searchs":_vm.enterSearch}}),_c('chartData')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }